<template>  
  <video autoplay="autoplay" preload="none" muted="muted" loop="true" id="myVideo"
  poster="@/assets/img/header-bg.jpeg">
    <source src="@/assets/video/fondo-piñata-may.mp4" type="video/mp4">
    <!--source media="(max-width: 480px)" src="@/assets/video/fondo-piñata-may.mp4" type="video/mp4"-->
  </video>  
</template>
<style scoped>
#myVideo {
  opacity: 0.7;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  height: auto;  
  z-index: -1;
}
@media screen and (max-width: 768px) {  
  #myVideo {    
    height: auto;
    left: 2%;
    top: 1%;
    transform: translate(-30%);
  }
}
/* Add some content at the bottom of the video/page */


/* Style the button used to pause/play the video */

</style>
<script setup>
import { onMounted, ref } from 'vue';
/*const playVideo = ()=>{
    const myVideo = document.getElementById('myVideo');  
    myVideo.play();
};*/
onMounted(() => {
  //playVideo
  
});
</script>